// Shared rune name to icon key mapping used across components
// This ensures consistency between RuneConfig3, SimpleRuneDisplay, and ChampionRuneBuild

export const runeNameToIconKey: Record<string, string> = {
  // Precision
  'Press the Attack': 'pressTheAttack',
  'Lethal Tempo': 'lethalTempo',
  'Fleet Footwork': 'fleetFootwork',
  'Conqueror': 'conqueror',
  'Absorb Life': 'absorbLife',
  'Triumph': 'triumph',
  'Presence of Mind': 'presenceOfMind',
  'Legend: Alacrity': 'legendAlacrity',
  'Legend: Haste': 'legendHaste',
  'Legend: Bloodline': 'legendBloodline',
  'Coup de Grace': 'coupDeGrace',
  'Cut Down': 'cutDown',
  'Last Stand': 'lastStand',

  // Domination
  'Electrocute': 'electrocute',
  'Dark Harvest': 'darkHarvest',
  'Hail of Blades': 'hailOfBlades',
  'Cheap Shot': 'cheapShot',
  'Taste of Blood': 'tasteOfBlood',
  'Sudden Impact': 'suddenImpact',
  'Sixth Sense': 'sixthSense',
  'Grisly Mementos': 'grislyMementos',
  'Deep Ward': 'deepWard',
  'Treasure Hunter': 'treasureHunter',
  'Relentless Hunter': 'relentlessHunter',
  'Ultimate Hunter': 'ultimateHunter',

  // Sorcery
  'Summon Aery': 'summonAery',
  'Arcane Comet': 'arcaneComet',
  'Phase Rush': 'phaseRush',
  'Manaflow Band': 'manaflowBand',
  'Nimbus Cloak': 'nimbusCloak',
  'Axiom Arcanist': 'axiomArcanist',
  'Transcendence': 'transcendence',
  'Celerity': 'celerity',
  'Absolute Focus': 'absoluteFocus',
  'Scorch': 'scorch',
  'Waterwalking': 'waterWalking',
  'Gathering Storm': 'gatheringStorm',

  // Resolve
  'Grasp of the Undying': 'graspOfTheUndying',
  'Aftershock': 'aftershock',
  'Guardian': 'guardian',
  'Demolish': 'demolish',
  'Font of Life': 'fontOfLife',
  'Shield Bash': 'shieldBash',
  'Conditioning': 'conditioning',
  'Second Wind': 'secondWind',
  'Bone Plating': 'bonePlating',
  'Overgrowth': 'overgrowth',
  'Revitalize': 'revitalize',
  'Unflinching': 'unflinching',

  // Inspiration
  'Glacial Augment': 'glacialAugment',
  'Unsealed Spellbook': 'unsealedSpellbook',
  'First Strike': 'firstStrike',
  'Hextech Flashtraption': 'hextechFlashtraption',
  'Magical Footwear': 'magicalFootwear',
  'Cash Back': 'cashback',
  'Triple Tonic': 'tripleTonic',
  'Time Warp Tonic': 'timeWarpTonic',
  'Biscuit Delivery': 'biscuitDelivery',
  'Cosmic Insight': 'cosmicInsight',
  'Approach Velocity': 'approachVelocity',
  'Jack Of All Trades': 'jackOfAllTrades',
};

// Helper function to get rune image URL using the updated approach
export const getRuneImageUrlByName = (
  runeName: string, 
  runeIcons: Record<string, string>, 
  fallbackUrl?: string
): string => {
  const iconKey = runeNameToIconKey[runeName];
  if (iconKey && runeIcons[iconKey]) {
    return runeIcons[iconKey];
  }
  
  return fallbackUrl || '';
};

// Helper function to get rune image URL by ID (for components that have rune IDs)
export const getRuneImageUrlById = (
  runeId: number,
  runeIdMapping: Record<number, any>,
  runeIcons: Record<string, string>,
  fallbackPath?: string
): string => {
  const runeInfo = runeIdMapping[runeId];
  if (!runeInfo) return '';
  
  const iconKey = runeNameToIconKey[runeInfo.name];
  if (iconKey && runeIcons[iconKey]) {
    return runeIcons[iconKey];
  }
  
  // Fallback to path-based approach
  if (runeInfo.path) {
    return `https://ddragon.leagueoflegends.com/cdn/img/perk-images/${runeInfo.path}`;
  }
  
  return fallbackPath || '';
};
